// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-shell layout for the iframe app: container transparency + the staged-init
   welcome layering / cross-fade (ADR 0039). Successor of livekit-overrides.css —
   the LiveKit UI styles are gone (@livekit/components-styles dropped with the
   React pill); \`.lk-room-container\` below is our own class on the <LiveKitRoom>
   wrapper, kept for continuity. */

.lk-room-container {
  width: 100% !important;
  height: 100% !important;
}

/* Transparent background for game overlay */
.ai-service-container,
.ai-service-container .lk-room-container,
.ai-service-container .ai-service-content,
.ai-service-container .voice-interface {
  background: transparent !important;
  background-color: transparent !important;
}

.ai-service-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* Staged-init welcome overlay: the presentational welcome shell (teach / cta) is
   layered ABOVE the LiveKitRoom subtree, which mounts underneath once a token
   lands. Absolutely positioned + z-indexed so it occupies the same box and wins
   the paint order; it unmounts when gamePhase leaves 'welcome'. */
.ai-service-welcome-overlay {
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

/* The overlay content is rendered only once the audio test resolves — fade it in so the widget
   appears smoothly (no pop-in) in its final state (teach or CTA). */
.ai-service-welcome-overlay > * {
  animation: ai-welcome-fade-in 0.28s ease-out both;
}

@keyframes ai-welcome-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* During the welcome the live room widget stays MOUNTED (room + audio keep connecting) but is kept
   visually HIDDEN via opacity (transitionable; audio is unaffected) — the welcome overlay is the only
   thing shown. Without this, the transparent welcome layer lets the regular widget show through during
   the audio-test window (a blink) and peek behind the teach/CTA. */
.lk-room-container {
  transition: opacity 0.3s ease;
}

.ai-service-welcome .lk-room-container {
  opacity: 0;
}

/* EXIT cross-fade: on EXIT_WELCOME the overlay fades OUT while the room fades IN, so the welcome →
   regular-widget hand-off is smooth (no abrupt swap, no blank frame). After the fade the game drops
   gamePhase to 'ingame' and .ai-service-welcome is removed, leaving the room at its normal opacity. */
.ai-service-welcome.ai-service-welcome-exiting .lk-room-container {
  opacity: 1;
}

.ai-service-welcome-exiting .ai-service-welcome-overlay {
  opacity: 0;
}

.ai-service-content {
  position: relative;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/app-shell.css"],"names":[],"mappings":"AAAA;;;;kCAIkC;;AAElC;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,4CAA4C;AAC5C;;;;EAIE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;kEAGkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;oEACoE;AACpE;EACE,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;;mEAGmE;AACnE;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;;sGAEsG;AACtG;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd","sourcesContent":["/* App-shell layout for the iframe app: container transparency + the staged-init\n   welcome layering / cross-fade (ADR 0039). Successor of livekit-overrides.css —\n   the LiveKit UI styles are gone (@livekit/components-styles dropped with the\n   React pill); `.lk-room-container` below is our own class on the <LiveKitRoom>\n   wrapper, kept for continuity. */\n\n.lk-room-container {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* Transparent background for game overlay */\n.ai-service-container,\n.ai-service-container .lk-room-container,\n.ai-service-container .ai-service-content,\n.ai-service-container .voice-interface {\n  background: transparent !important;\n  background-color: transparent !important;\n}\n\n.ai-service-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n/* Staged-init welcome overlay: the presentational welcome shell (teach / cta) is\n   layered ABOVE the LiveKitRoom subtree, which mounts underneath once a token\n   lands. Absolutely positioned + z-indexed so it occupies the same box and wins\n   the paint order; it unmounts when gamePhase leaves 'welcome'. */\n.ai-service-welcome-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 30;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.3s ease;\n}\n\n/* The overlay content is rendered only once the audio test resolves — fade it in so the widget\n   appears smoothly (no pop-in) in its final state (teach or CTA). */\n.ai-service-welcome-overlay > * {\n  animation: ai-welcome-fade-in 0.28s ease-out both;\n}\n\n@keyframes ai-welcome-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* During the welcome the live room widget stays MOUNTED (room + audio keep connecting) but is kept\n   visually HIDDEN via opacity (transitionable; audio is unaffected) — the welcome overlay is the only\n   thing shown. Without this, the transparent welcome layer lets the regular widget show through during\n   the audio-test window (a blink) and peek behind the teach/CTA. */\n.lk-room-container {\n  transition: opacity 0.3s ease;\n}\n\n.ai-service-welcome .lk-room-container {\n  opacity: 0;\n}\n\n/* EXIT cross-fade: on EXIT_WELCOME the overlay fades OUT while the room fades IN, so the welcome →\n   regular-widget hand-off is smooth (no abrupt swap, no blank frame). After the fade the game drops\n   gamePhase to 'ingame' and .ai-service-welcome is removed, leaving the room at its normal opacity. */\n.ai-service-welcome.ai-service-welcome-exiting .lk-room-container {\n  opacity: 1;\n}\n\n.ai-service-welcome-exiting .ai-service-welcome-overlay {\n  opacity: 0;\n}\n\n.ai-service-content {\n  position: relative;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
